// src/components/dashboard/modals/DeleteCourseModal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

function DeleteCourseModal({
  isOpen,
  onClose,
  onConfirm,
  courseName,
  isDeleting,
  error
}) {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white rounded-xl p-6 sm:p-8 max-w-md w-full shadow-2xl">
        <h3 className="text-xl font-bold text-slate-800 mb-4">{t('courses.modals.delete.title')}</h3>

        <p className="text-slate-600 mb-6">
          {t('courses.modals.delete.confirmMessage', { courseName })}
        </p>

        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-300 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors"
            disabled={isDeleting}
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
            disabled={isDeleting}
          >
            {isDeleting ? t('courses.modals.delete.deleting') : t('courses.modals.delete.deleteButton')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteCourseModal;